import { TranslationProvider } from "@mittwald/flow-components/dist/components/TranslationProvider";
import { Section as NewSection } from "@mittwald/flow-react-components";
import React from "react";
import { CompareSection } from "./components/CompareSection/CompareSection";
import { DomainList } from "./components/DomainList";

export const AdditionalServicesStepContent: React.FC = () => {
  return (
    <TranslationProvider name="additionalServicesStepContent" type="component">
      <NewSection>
        <CompareSection />
      </NewSection>
      <NewSection>
        <DomainList />
      </NewSection>
    </TranslationProvider>
  );
};
